<template>
    <section>
        <div class="ask_section1" style="display: flex; justify-content: flex-end; flex-direction: column; position: relative;">
            <div class="mobile_con_wrap" style="display: flex; flex-direction: column; align-items: flex-start; padding-top: 195px; margin-bottom: 24px;">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 300; text-align: left; margin-bottom: 22px;">
                    제안 및 사업 문의
                </p>
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 400; text-align: left;">
                    안녕하세요 필드유입니다.<br>
                    제안 및 사업 문의는 언제든지 연락주세요.
                </p>
            </div>
            <img src="@/assets/images/main_v2/mobile_background_section4.svg" alt="" style="width: 100%; object-fit: cover;">
            <!-- <div style="height: calc((var(--vh, 1vh) * 100) - 307px); overflow: hidden;">
            </div> -->
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    },
    // mounted() {
    //     let vh = window.innerHeight * 0.01;
    //     document.documentElement.style.setProperty('--vh', `${vh}px`);
    // }
}
</script>
<style>
    .ask_section1 {
        width: 100vw;
        height:calc(var(--vh, 1vh) * 100);
        object-fit: inherit;
    }
</style>